<template>
    <div class="ls-filter">
        <div class="filter" ref="box">
            <el-input v-model="add.kw" :placeholder="kw" :style="{ width: width }"></el-input>
            <slot></slot>
        </div>
    </div>
</template>
<script>
export default {
    props: {
        table: {},
        width: {
            default: '400px'
        }
    },
    data() {
        return {
            add: {},
            kw: '',
            is_more: true,
            is_ex: false
        };
    },
    watch: {
        add: {
            deep: true,
            handler(val) {
                this.$emit('change', val);
            }
        }
    },
    created() {
        this.$http
            .post('table/kw_field', {
                table: this.table
            })
            .then((res) => {
                this.kw = `${res.data}关键词`;
            });
    },
    mounted() {
        let h = this.$refs.box.offsetHeight;
        console.log(h);
        let m = 63 + (99 - 63) / 2;
        if (h > m) {
            this.is_more = true;
        } else {
            this.is_more = false;
        }
    },
    methods: {}
};
</script>
<style lang="scss" scoped>
@import 'index.scss';
</style>